import MedicalCard from "../MedicalCard";
import {
  faqPoints,
  howItWorks,
} from "../../componentsUpdated/constants/Common";
import CustomAccordion from "../Accordion";
import { Link } from "react-router-dom";

const HowItWorks = () => {
  return (
    <section className="!px-4 md:!px-10 bg-lightGray">
      <div className="max-w-custom mx-auto">
        <div className="!pt-13.5 md:!pt-32" id="faqs">
          <div className="text-6.5 md:text-6xl leading-14 font-medium text-primaryText text-center font-halyard">
            How It Works
          </div>
          <div className="grid gap-x-7 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 !mt-5 md:!mt-16 bg-lightGray">
            {howItWorks?.map((ele, idx) => (
              <MedicalCard key={idx} {...ele} />
            ))}
          </div>
          <div className="flex justify-center items-center !pt-6 !pb-13.5 md:!pt-16 md:!pb-24 w-full">
            <Link to={"/register"}>
              <div className="uppercase w-fit font-semibold py-3 px-4 hover:bg-lightestGreen bg-midGreen cursor-pointer text-white text-sm tracking-0.5px">
                Sign up for free
              </div>
            </Link>
          </div>
          <div className="text-2xl md:text-[2.765em] font-medium md:leading-14 md:font-normal tracking-normal text-primaryText text-center font-halyard">
            Frequently Asked Questions
          </div>
          <div className="font-normal font-dm-sans  text-midGray text-md leading-7 text-center capitalize !py-2.5 md:!py-5 tracking-normal">
            Learn more about our services
          </div>
          <div className="flex justify-center items-center">
            <div className=" md:w-2/3">
              <CustomAccordion data={faqPoints} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
